// Flickity emits a 'scroll' event on every animation frame while a slider moves, and re-dispatches
// each event through jQuery ($element.trigger). For a jQuery event named 'scroll', trigger() also runs
// the element's native default action, i.e. element.scroll(), so every animating slider (the homepage
// slideshow, product galleries) paid a jQuery dispatch plus a native scroll call per frame. Nothing in
// the theme listens to 'scroll.flickity', so 'scroll' now goes to Flickity's own listeners only; every
// other Flickity event (select, change, staticClick, ...) still reaches jQuery exactly as before.
// Loaded deferred straight after vendor.js, so the prototype is patched before any slider dispatches.
(function () {
  var F = window.Flickity;
  if (!F || !F.prototype || F.prototype.__hdsScrollPatched) return;
  var original = F.prototype.dispatchEvent;
  F.prototype.dispatchEvent = function (type, event, args) {
    if (type === 'scroll') {
      this.emitEvent(type, event ? [event].concat(args) : args);
      return;
    }
    return original.apply(this, arguments);
  };
  F.prototype.__hdsScrollPatched = true;
})();
